import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from '../../../hooks/redux'
import { setModalVisibility, updateModalSettings } from '../../../store/slices/admin/adminSlice'
import { setSelectedUsers } from '../../../store/slices/statisticsConsole/consoleSlice'
import { CustomIcon } from '../../../components/customIcon/customIcon'
import { IUser } from '../../../@types/user'
import classes from '../../../styles/admin/usersListItemMenu.module.scss'


export const UsersListItemMenu: FC<{
    config: IUser
    tokenVisible: boolean
    onToggleToken: () => void
    setOpen?: (open: boolean) => void
}> = ({ config, tokenVisible, onToggleToken, setOpen }) => {
    const dispatch = useDispatch()
    const adminSelectedUsers = useSelector((state) => state.admin.selectedUsers)
    const users = useSelector((state) => state.user.users)

    const close = () => setOpen?.(false)

    const handleCopyToken = () => {
        navigator.clipboard.writeText(config.auth_token ?? '')
        close()
    }

    const handleRedirect = () => {
        if (adminSelectedUsers.includes(config.user_id)) {
            dispatch(setSelectedUsers(adminSelectedUsers.map(uId => users.find(u => u.user_id === uId)?.auth_username || '')))
        } else {
            dispatch(setSelectedUsers([config.auth_username]))
        }
        close()
    }

    const handleToggleToken = () => {
        onToggleToken()
        close()
    }

    const handleVoiceGroups = () => {
        dispatch(setModalVisibility('voiceGroups'))
        dispatch(updateModalSettings(config))
        close()
    }

    const handleDelete = () => {
        dispatch(setModalVisibility('delete'))
        dispatch(updateModalSettings(config))
        close()
    }

    return (
        <div className={classes.menu}>
            <button className={classes.menuItem} onClick={handleCopyToken}>
                <CustomIcon icon="copy" />
                Скопировать токен
            </button>
            {!config.access_admin && (
                <button className={classes.menuItem} onClick={handleVoiceGroups}>
                    <CustomIcon icon="lockOpen" />
                    Доступ к группам
                </button>
            )}
            <Link to="/console" className={classes.menuItem} onClick={handleRedirect}>
                <CustomIcon icon="back" />
                Перейти в консоль
            </Link>
            <button className={classes.menuItem} onClick={handleToggleToken}>
                <CustomIcon icon={tokenVisible ? 'showIcon' : 'hideIcon'} />
                {tokenVisible ? 'Скрыть токен' : 'Показать токен'}
            </button>
            <button className={`${classes.menuItem} ${classes.menuItemDanger}`} onClick={handleDelete}>
                <CustomIcon icon="delete" />
                Удалить пользователя
            </button>
        </div>
    )
}
